<template>
  <ok-text-input
    :value="value"
    is-append-text
    is-append-merged
    :placeholder="$t('help.search-help')"
    @input="$emit('input', $event)"
  >
    <template #append>
      <feather-icon icon="SearchIcon" />
    </template>
  </ok-text-input>
</template>

<script>
import OkTextInput from '@/@okmenu/components/inputs/OkTextInput'

export default {
  name: 'HelpSearchInput',
  components: { OkTextInput },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
}
</script>
